import { useEffectOnce } from "react-use"

import { MapAdapterFeature } from "@l2r-front/l2r-networks"
import { useIsMobileDevice } from "@l2r-front/l2r-ui"

import { useRoadworksDispatchContext } from "../../contexts/RoadworksContext"
import { useRoadwork } from "../../hooks/queries/useRoadwork"

type RoadworkSectionAdapterProps = {
    roadworkUuid: string
}

export function RoadworkSectionAdapter(props: RoadworkSectionAdapterProps) {

    const { roadworkUuid } = props
    const { data } = useRoadwork(roadworkUuid, null, {}, { "as_geojson": true })
    const { setSelectedSegment } = useRoadworksDispatchContext()
    const isMobile = useIsMobileDevice()

    useEffectOnce(() => {
        if (data && isMobile) {
            const selectedFeature = {
                ...data,
                properties: {
                    ...data.properties,
                    linearLocation: JSON.stringify(data.linearLocation),
                },
            }
            setSelectedSegment(selectedFeature)
        }
    })

    return <MapAdapterFeature feature={data} />
}